var map = {
	"./404.vue": [
		"8cdb",
		"chunk-2d0e95df"
	],
	"./Biblioteca.vue": [
		"4860",
		"chunk-3a39f4fa"
	],
	"./Busca.vue": [
		"444e",
		"chunk-d58bc1c2"
	],
	"./Categoria.vue": [
		"0c3d",
		"chunk-737c195a"
	],
	"./Categorias.vue": [
		"f1c1",
		"chunk-805368c2"
	],
	"./Edicao.vue": [
		"91d5",
		"chunk-6ee3ad92"
	],
	"./EdicaoImage.vue": [
		"4ee6",
		"chunk-59531ab9",
		"chunk-47d33c0e"
	],
	"./EdicaoPages.vue": [
		"60f6",
		"chunk-59531ab9",
		"chunk-7bd7ce3f"
	],
	"./EdicaoVideo.vue": [
		"4358",
		"chunk-17290280"
	],
	"./Explorar.vue": [
		"7b70",
		"chunk-1ec679a8"
	],
	"./Faq.vue": [
		"10c2",
		"chunk-9c149102"
	],
	"./Favoritos.vue": [
		"5628",
		"chunk-78562cab"
	],
	"./Home.vue": [
		"bb51",
		"chunk-15477730"
	],
	"./Integracao.vue": [
		"d956",
		"chunk-10d1b2ed",
		"chunk-7b6dbfc3"
	],
	"./Layout.vue": [
		"88e9",
		"chunk-09ce73d7",
		"chunk-2dbfa718"
	],
	"./Login.vue": [
		"a55b",
		"chunk-586e750a"
	],
	"./LoginAzul.vue": [
		"a970",
		"chunk-ec3b8366"
	],
	"./LoginDinamico.vue": [
		"1484",
		"chunk-6f717ead"
	],
	"./LoginIsp.vue": [
		"b94b",
		"chunk-1face103"
	],
	"./LoginMonetoLab.vue": [
		"e6c4",
		"chunk-fd87f148"
	],
	"./LoginNeo.vue": [
		"0840",
		"chunk-0c1dd4e4"
	],
	"./LoginParceiros.vue": [
		"3114",
		"chunk-05bd8a34"
	],
	"./LoginPhone.vue": [
		"4738",
		"chunk-2a8e73da"
	],
	"./LoginSercomtel.vue": [
		"9d01",
		"chunk-9478811c"
	],
	"./LoginTpnet.vue": [
		"dd75",
		"chunk-0b52c9e0"
	],
	"./LoginVenezuela.vue": [
		"d4e3",
		"chunk-58b2d136"
	],
	"./Logout.vue": [
		"c100",
		"chunk-2d215fa4"
	],
	"./Perfil.vue": [
		"68f9",
		"chunk-7b63e21a"
	],
	"./PerfilEditar.vue": [
		"c843",
		"chunk-e25ab93a"
	],
	"./PerfilEditarFone.vue": [
		"f775",
		"chunk-09ce73d7",
		"chunk-18bf65f5"
	],
	"./PerfilFaq.vue": [
		"9130",
		"chunk-1a4a2fe4"
	],
	"./PerfilInfantil.vue": [
		"7e0b",
		"chunk-4306a4b4"
	],
	"./PerfilPolitica.vue": [
		"1abb",
		"chunk-5bfcd2d9"
	],
	"./PerfilPremium.vue": [
		"05b4",
		"chunk-b05cc328"
	],
	"./PerfilTermos.vue": [
		"be6b",
		"chunk-3e9e36e2"
	],
	"./Playlist.vue": [
		"2059",
		"chunk-6418a2d8"
	],
	"./Politica.vue": [
		"40a9",
		"chunk-2bdffdc4"
	],
	"./RedirectApp.vue": [
		"b02f",
		"chunk-296cd937"
	],
	"./Skeelo.vue": [
		"439a",
		"chunk-ec2520c4"
	],
	"./Subscription.vue": [
		"d7e2",
		"chunk-01b41cac"
	],
	"./Termos.vue": [
		"f2e1",
		"chunk-ec886728"
	],
	"./TesteCoquetel.vue": [
		"b413",
		"chunk-46dc3387"
	],
	"./Titulo.vue": [
		"4dd7",
		"chunk-4d058e38"
	],
	"./Welcome.vue": [
		"eec5",
		"chunk-10d1b2ed",
		"chunk-dc432690"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;